import React from 'react';
import { colors, spacing } from '../design-system/tokens';
import { Typography } from '../design-system/typography';

export interface ContractDataRowProps {
  label: string;
  value: string | number | React.ReactNode;
  className?: string;
}

export const ContractDataRow: React.FC<ContractDataRowProps> = ({
  label,
  value,
  className = '',
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.xs,
        minWidth: 0, // Allow shrinking
        width: '100%',
      }}
    >
      {/* Label */}
      <Typography 
        variant="ledgerLabel" 
        as="div"
        style={{ 
          color: colors.text.primary,
          textTransform: 'uppercase'
        }}
      >
        {label}
      </Typography>

      {/* Value */}
      <Typography
        variant="valueAddress"
        as="div"
        style={{
          color: colors.text.primary,
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {typeof value === 'string' || typeof value === 'number' ? String(value) : value}
      </Typography>
    </div>
  );
};